import React, { useEffect, useState } from 'react';

const CATEGORIES = [
  { val:'MACHINE_FUEL',   label:'Machine Fuel',                 icon:'⛽' },
  { val:'DELIVERY',       label:'Delivery Expenses',            icon:'🚛' },
  { val:'PURCHASE',       label:'Purchase / Materials',         icon:'🛒' },
  { val:'SALARY',         label:'Salary / Wages',               icon:'💰' },
  { val:'EMPLOYEE',       label:'Employee Expenses',            icon:'👷' },
  { val:'FOOD',           label:'Food Expenses',                icon:'🍱' },
  { val:'TRAVEL',         label:'Travel Expenses',              icon:'✈️' },
  { val:'ELECTRICITY',    label:'Electricity Bill',             icon:'⚡' },
  { val:'GENERATOR_FUEL', label:'Generator Fuel',               icon:'🔋' },
  { val:'MAINTENANCE',    label:'Machine Maintenance / Repair', icon:'🔧' },
  { val:'RENT',           label:'Rent',                         icon:'🏢' },
  { val:'COMMUNICATION',  label:'Communication',                icon:'📱' },
  { val:'OFFICE',         label:'Office Expenses',              icon:'📋' },
  { val:'VEHICLE_MAINT',  label:'Vehicle Maintenance',          icon:'🚗' },
  { val:'MEDICAL_SAFETY', label:'Medical / Safety',             icon:'💊' },
  { val:'OTHER',          label:'Other Expenses',               icon:'📌' },
];

const inr = v => `₹${Number(v||0).toLocaleString('en-IN',{minimumFractionDigits:2})}`;

export default function PrintExpenseReportPage() {
  const [data, setData] = useState(null);

  useEffect(()=>{
    const stored = sessionStorage.getItem('printExpenseReport');
    if(stored) {
      setData(JSON.parse(stored));
      setTimeout(()=>window.print(), 1000);
    }
  }, []);

  if(!data) return <div style={{padding:20,fontFamily:'Arial'}}>Loading report...</div>;

  const { expenses, totalExpenses, totalRevenue, netProfit, byCategory, filters, reportNumber } = data;

  return (
    <div style={{fontFamily:'Inter,Arial,sans-serif',fontSize:13,color:'#333',padding:'10mm',maxWidth:'210mm',margin:'0 auto'}}>
      <style>{`
        @media print {
          @page { margin: 8mm; size: A4; }
          body { margin: 0; }
        }
        * { box-sizing: border-box; }
      `}</style>

      {/* Company Header */}
      <div style={{borderBottom:'3px solid #1e3a5f',paddingBottom:8,marginBottom:12,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <div style={{display:'flex',alignItems:'center',gap:12}}>
          <img src="/TycheAbodes-logo1.png" alt="Logo" style={{width:50,height:50,objectFit:'contain'}} onError={e=>e.target.style.display='none'}/>
          <div>
            <div style={{fontSize:17,fontWeight:800,color:'#1e3a5f',fontFamily:'Inter,sans-serif'}}>TYCHE ABODES PRIVATE LIMITED</div>
            <div style={{fontSize:12,color:'#555'}}>No. 401, Ramani's Frazer Square,</div>
            <div style={{fontSize:12,color:'#555'}}>Near Head Post Office, Goods Shed Road, Coimbatore - 641001.</div>
            <div style={{fontSize:12,color:'#555'}}>📞 +91 94433 23246 &nbsp;|&nbsp; GSTIN: 33AAKCT5967G1ZY</div>
          </div>
        </div>
        <div style={{textAlign:'right'}}>
          <div style={{fontSize:16,fontWeight:800,color:'#1e3a5f',textTransform:'uppercase',letterSpacing:1}}>Expense Report</div>
          <div style={{fontSize:12,color:'#555',marginTop:3}}>Report No: <strong>{reportNumber}</strong></div>
          <div style={{fontSize:12,color:'#555'}}>Period: <strong>{filters?.from} — {filters?.to}</strong></div>
          <div style={{fontSize:12,color:'#555'}}>Generated: <strong>{new Date().toLocaleDateString('en-IN')}</strong></div>
        </div>
      </div>

      {/* P&L Summary */}
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',border:'1px solid #ddd',borderRadius:6,overflow:'hidden',marginBottom:14}}>
        <div style={{padding:'10px 14px',textAlign:'center',background:'#f0fdf4',borderRight:'1px solid #ddd'}}>
          <div style={{fontSize:10,color:'#555',textTransform:'uppercase',letterSpacing:'0.5px',marginBottom:4}}>Total Revenue</div>
          <div style={{fontFamily:'DM Mono,monospace',fontSize:22,fontWeight:700,color:'#3B6D11'}}>{inr(totalRevenue||0)}</div>
        </div>
        <div style={{padding:'10px 14px',textAlign:'center',background:'#fef2f2',borderRight:'1px solid #ddd'}}>
          <div style={{fontSize:10,color:'#555',textTransform:'uppercase',letterSpacing:'0.5px',marginBottom:4}}>Total Expenses</div>
          <div style={{fontFamily:'DM Mono,monospace',fontSize:22,fontWeight:700,color:'#C0392B'}}>{inr(totalExpenses||0)}</div>
        </div>
        <div style={{padding:'10px 14px',textAlign:'center',background:netProfit>=0?'#f0fdf4':'#fef2f2'}}>
          <div style={{fontSize:10,color:'#555',textTransform:'uppercase',letterSpacing:'0.5px',marginBottom:4}}>{netProfit>=0?'Net Profit':'Net Loss'}</div>
          <div style={{fontFamily:'DM Mono,monospace',fontSize:22,fontWeight:700,color:netProfit>=0?'#3B6D11':'#C0392B'}}>{inr(Math.abs(netProfit||0))}</div>
          <div style={{fontSize:11,fontWeight:700,color:netProfit>=0?'#3B6D11':'#C0392B'}}>{netProfit>=0?'✅ PROFIT':'❌ LOSS'}</div>
        </div>
      </div>

      {/* Category Summary */}
      {byCategory && Object.keys(byCategory).length > 0 && (
        <div style={{marginBottom:14}}>
          <div style={{fontSize:12,fontWeight:700,color:'#1e3a5f',textTransform:'uppercase',letterSpacing:'1px',borderBottom:'2px solid #1e3a5f',paddingBottom:4,marginBottom:8}}>Expenses by Category</div>
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
            <thead>
              <tr style={{background:'#1e3a5f',color:'#fff'}}>
                <th style={{padding:'6px 8px',textAlign:'left'}}>Category</th>
                <th style={{padding:'6px 8px',textAlign:'center'}}>Records</th>
                <th style={{padding:'6px 8px',textAlign:'right'}}>Amount</th>
                <th style={{padding:'6px 8px',textAlign:'right'}}>% of Total</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(byCategory).sort((a,b)=>b[1].total-a[1].total).map(([cat,info],i)=>{
                const catInfo = CATEGORIES.find(c=>c.val===cat);
                const pct = totalExpenses>0?(info.total/totalExpenses*100).toFixed(1):0;
                return (
                  <tr key={i} style={{background:i%2===0?'#f8f9fc':'#fff',borderBottom:'1px solid #eee'}}>
                    <td style={{padding:'5px 8px'}}>{catInfo?.icon} {catInfo?.label||cat}</td>
                    <td style={{padding:'5px 8px',textAlign:'center',fontFamily:'monospace'}}>{info.count}</td>
                    <td style={{padding:'5px 8px',textAlign:'right',fontFamily:'monospace',fontWeight:600,color:'#C0392B'}}>{inr(info.total)}</td>
                    <td style={{padding:'5px 8px',textAlign:'right',fontFamily:'monospace'}}>{pct}%</td>
                  </tr>
                );
              })}
              <tr style={{background:'#1e3a5f',color:'#fff',fontWeight:700}}>
                <td style={{padding:'6px 8px'}}>TOTAL</td>
                <td style={{padding:'6px 8px',textAlign:'center',fontFamily:'monospace'}}>{expenses?.length||0}</td>
                <td style={{padding:'6px 8px',textAlign:'right',fontFamily:'monospace'}}>{inr(totalExpenses||0)}</td>
                <td style={{padding:'6px 8px',textAlign:'right'}}>100%</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* Expense Records */}
      <div>
        <div style={{fontSize:12,fontWeight:700,color:'#1e3a5f',textTransform:'uppercase',letterSpacing:'1px',borderBottom:'2px solid #1e3a5f',paddingBottom:4,marginBottom:8}}>Expense Records</div>
        <table style={{width:'100%',borderCollapse:'collapse',fontSize:11}}>
          <thead>
            <tr style={{background:'#1e3a5f',color:'#fff'}}>
              <th style={{padding:'5px 8px',textAlign:'left'}}>Exp #</th>
              <th style={{padding:'5px 8px',textAlign:'left'}}>Date</th>
              <th style={{padding:'5px 8px',textAlign:'left'}}>Category</th>
              <th style={{padding:'5px 8px',textAlign:'left'}}>Vendor</th>
              <th style={{padding:'5px 8px',textAlign:'left'}}>Payment</th>
              <th style={{padding:'5px 8px',textAlign:'left'}}>Notes</th>
              <th style={{padding:'5px 8px',textAlign:'right'}}>Amount</th>
            </tr>
          </thead>
          <tbody>
            {(expenses||[]).map((e,i)=>{
              const cat = CATEGORIES.find(c=>c.val===e.category);
              return (
                <tr key={i} style={{background:i%2===0?'#f8f9fc':'#fff',borderBottom:'1px solid #eee'}}>
                  <td style={{padding:'4px 8px',color:'#1e3a5f',fontWeight:600,fontFamily:'monospace',fontSize:10}}>{e.expense_number}</td>
                  <td style={{padding:'4px 8px',fontFamily:'monospace',fontSize:10}}>{e.date}</td>
                  <td style={{padding:'4px 8px'}}>{cat?.icon} {cat?.label||e.category}</td>
                  <td style={{padding:'4px 8px',color:'#555'}}>{e.vendor_name||'—'}</td>
                  <td style={{padding:'4px 8px'}}>{e.payment_mode}</td>
                  <td style={{padding:'4px 8px',color:'#444',wordBreak:'break-word'}}>{e.notes}</td>
                  <td style={{padding:'4px 8px',fontFamily:'monospace',fontWeight:700,color:'#C0392B',textAlign:'right'}}>{inr(e.amount)}</td>
                </tr>
              );
            })}
            <tr style={{background:'#1e3a5f',color:'#fff',fontWeight:700}}>
              <td colSpan={6} style={{padding:'6px 8px'}}>TOTAL EXPENSES</td>
              <td style={{padding:'6px 8px',fontFamily:'monospace',textAlign:'right'}}>{inr(totalExpenses||0)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <div style={{borderTop:'2px solid #1e3a5f',paddingTop:8,marginTop:14,display:'flex',justifyContent:'space-between',fontSize:10,color:'#666'}}>
        <span>TYCHE ABODES PRIVATE LIMITED — Confidential</span>
        <span>Report: {reportNumber} | Generated: {new Date().toLocaleString('en-IN')}</span>
      </div>
    </div>
  );
}